import PubSub from 'pubsub-js'
import { useEffect } from 'react'
interface PubSubEvent<Data> {
  message: string | symbol
  data?: Data
}

export interface EventCallback<Data> {
  (data: Data): void
}

export const OPPORTUNITY_STATUS_CHANGED_EVENT = 'OPPORTUNITY_STATUS_CHANGED'

export function useEvent<Event extends PubSubEvent<Event['data']>>(
  message: Event['message'],
  callback: EventCallback<Event['data']>
) {
  useEffect(() => {
    const token = PubSub.subscribe(message, (_, data) => {
      callback(data)
    })

    return () => {
      PubSub.unsubscribe(token)
    }
  }, [message, callback])
}
